<form [formGroup]="form" class="preference-form">
  <div class="row">
    <!-- <div class="col-sm-4">
      <mat-checkbox
        matTooltip="Allow this House Staff to see guest name"
        matTooltipPosition="above"
        formControlName="guest_name"
      >
        Show Guest Name
      </mat-checkbox>
    </div> -->
    <div class="col-sm-4">
      <mat-checkbox
        matTooltip="Allow this House Staff to see guest email"
        matTooltipPosition="above"
        i18n-matTooltip
        formControlName="guest_email"
        i18n
      >
        Show Guest Email
      </mat-checkbox>
    </div>
    <div class="col-sm-4">
      <mat-checkbox
        matTooltip="Allow this House Staff to see guest phone"
        matTooltipPosition="above"
        i18n-matTooltip
        formControlName="guest_phone"
        i18n
      >
        Show Guest Phone
      </mat-checkbox>
    </div>
    <div class="col-sm-4">
      <mat-checkbox
        matTooltip="Allow this House Staff to see booking comments"
        matTooltipPosition="above"
        i18n-matTooltip
        formControlName="booking_comments"
        i18n
      >
        Show Booking Comments
      </mat-checkbox>
    </div>
  </div>
</form>
